import React from 'react';
import { BCMSRecord, BCMSStateManagerCRUD, useGlobalController, useRoute } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import { PageContainer } from 'components/shared';
import ReorderAccountsContent from "./components/ReorderAccountsContent";

import "./styles.css";
import "./mobile.css";

/**
 * @function ReorderAccountsPage
 * @return {React.Component}
 * @exported true
 * @description The page that shows the list of accounts
 */
export default function ReorderAccountsPage(props) {
    const globalController = useGlobalController();
    const navigate = useRoute();

    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
    const className = props.className ? (" " + props.className) : "";

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
        setState,

        onReset: evt => {
            BCMSStateManagerCRUD.init(state)
                .update(["data", "accounts"], Account.initAll())
                .submit(setState);
        },
        onCancel: evt => navigate("/accountSummary")
    });

    return (
        <PageContainer className={"reorder-accounts-page " + className} state={{ data, ui }} controller={controller}>
            <ReorderAccountsContent />
        </PageContainer>
    );
}

export const getDefaultPageData = () => ({
    accounts: Account.initAll()
});
export const getDefaultPageUI = () => ({
    showResetBanner: false,
    showVisibilityBanner: false
});

